<template>
    <div>
        <b-list-group class="list-group-accent">
            <!-- FÓRMULA -->
            <c-settings-list
                :title="$t('targets.automaticCalculation')"
                :subtitle="$t('targets.enableAutomaticCalculation')"
                description=""
            >
                <button
                    slot="actionButton"
                    @click="openAutomaticCalculationModal"
                    type="button"
                    class="float-right btn btn-ghost-primary btn-pill btn-sm"
                >
                    {{ $t('form.button.edit') }}
                </button>
                <b-card v-if="target.formulaHtml" class="mt-4 text-justify">
                    <span v-html="target.formulaHtml"></span>
                </b-card>
            </c-settings-list>
        </b-list-group>
    </div>
</template>

<script>
import CSettingsList from '@/views/target/components/view/tab-content/settings-list'

export default {
    name: 'Settings',
    props: ['target', 'currentEventPermissions'],
    components: {
        CSettingsList,
    },
    methods: {
        openAutomaticCalculationModal() {
            this.$router.push({
                path: `/v2/target/indicators/view/${this.target.id}/automatic-calculation`,
            })
        },
    },
}
</script>
